import DateFnsUtils from '@date-io/moment'

export const dateUTCToLocalString = (date) => {
    const dateFns = new DateFnsUtils()
    if (!date) return '-'
    return dateFns.moment.utc(date).local().format('YYYY-MM-DD HH:mm:ss')
}
